import { Color, SvgGraphics, Component, ColorFill, PointerEvents } from '@tencent/alloy-renderer';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { CANVAS_TABLE_CELL_SELECT_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';

export class TableSelectonComponent extends Component {
    private cachedSelections: Map<string, SvgGraphics>;

    public constructor(private factoryOptions: InterfaceFactoryOptions<ITableModel>) {
        super();
        this.factoryOptions = factoryOptions;
        this.cachedSelections = new Map();
    }

    public updateComponent(): void {
        const resueKeys = Array.from(this.cachedSelections.keys());

        const { model } = this.factoryOptions;
        model.tableItems.forEach((rowInfo) => {
            rowInfo.forEach((cell) => {
                if (!cell.hMerge && !cell.vMerge && model.selectedRange && model.showSelection
                    && model.cellSelectedState(cell.row, cell.col, model.selectedRange)) {
                    let selection = this.cachedSelections.get(cell.key);
                    if (!selection) {
                        selection = new SvgGraphics();
                        selection.fill = new ColorFill(Color.fromHex('#60a0f3', 0.7));
                        selection.pointerEvents = PointerEvents.NONE;
                        this.addChild(selection);
                        this.cachedSelections.set(cell.key, selection);
                    } else {
                        resueKeys.splice(resueKeys.indexOf(cell.key), 1);
                    }
                    const { left, top, width, height } = cell.props.style;
                    selection.path = `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
                    selection.x = left;
                    selection.y = top;
                    selection.id = `${CANVAS_TABLE_CELL_SELECT_ID_PREFIX}-${cell.row}-${cell.col}`;
                }
            });
        });

        resueKeys.forEach((key) => {
            const selector = this.cachedSelections.get(key);
            if (selector) {
                this.removeChild(selector);
                this.cachedSelections.delete(key);
            }
        });
    }
}
